<script>
import api from '@/api'
import pagination from '@/components/pagination.vue'

export default {
  props: {
    status: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      loading: true,
      pagetitle: 'Device Types',
      deviceTypes: [],
      totalItems: 0,
      totalPages: 1,
      currentPage: 0,
      perPage: 10,
      baseUrl: `${window.apiUrl}/device-types/list`,
      exportBtnDisabled: false,
      // statuses: ['critical', 'trouble', 'attention', 'clear', 'maintenance'],
      filters: {
        status: null,
      },
      sortBy: 'id',
      sortDir: 'asc',
      columns: [
        { name: 'deviceType', label: 'Device Type', sortable: true },
        { name: 'description', label: 'Description', sortable: true },
        { name: 'tags', label: 'Tags', sortable: false },
        { name: 'details', label: 'Interfaces', sortable: false },
        { name: 'cpuCount', label: 'CPU Count', sortable: false },
      ],
    }
  },
  components: {
    pagination,
  },
  mounted() {
    this.getDeviceTypes()
  },
  methods: {
    getDeviceTypes() {
      this.loading = true
      const params = {
        page: this.currentPage,
        size: this.perPage,
        sortBy: this.sortBy,
        sortDir: this.sortDir,
      }
      api
        .get(this.baseUrl, { params })
        .then((response) => {
          this.deviceTypes = response.data?.deviceTypes || []
          this.totalItems = response.data.totalItems
          this.totalPages = response.data.totalPages
          this.currentPage = response.data.currentPage
        })
        .finally(() => {
          this.loading = false
        })
    },

    // deleteDevice(id) {
    //   alertConfirm('You want to delete this device').then((result) => {
    //     if (result.value) {
    //       api.post(`/deviceTypes/delete/${id}`).then(() => {
    //         alertSuccess('Device deleted successfully')
    //         this.getDeviceTypes()
    //       })
    //     }
    //   })
    // },

    applyFilters() {
      this.currentPage = 0
      this.getDeviceTypes()
    },

    sortByColumn(column) {
      if (column.sortable) {
        this.sortBy = column.name
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
        this.currentPage = 0
        this.getDeviceTypes()
      }
    },

    updatePage(newPage) {
      this.currentPage = newPage - 1
      this.getDeviceTypes()
    },
  },
}
</script>

<template>
  <Teleport to="#elePageTitle">
    {{ pagetitle }}
  </Teleport>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <!-- <div class="card-header">
          <div class="row g-3 align-items-center">
            <div class="col-lg-4 col-md-6">
              <div class="input-group">
                <input type="search" class="form-control" placeholder="Search here" />
                <span class="input-group-text cursor-pointer">
                  <i class="bx bx-search"></i>
                </span>
              </div>
            </div>
          </div>
        </div> -->
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th v-for="(column, columnIndex) in columns" :key="columnIndex" @click="sortByColumn(column)" :class="column.sortable ? 'cursor-pointer' : ''">
                        <div class="d-flex align-itmes-center justify-content-between">
                          <span>{{ column.label }}</span>
                          <i v-if="sortBy === column.name" :class="'bx bx-sort-' + (sortDir === 'asc' ? 'up' : 'down') + ' font-size-20'"></i>
                          <i v-else-if="column.sortable" class="bx bx-sort font-size-20"></i>
                        </div>
                      </th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr v-for="n in 5" :key="n">
                        <td v-for="m in 6" :key="m" class="placeholder-glow">
                          <span class="placeholder col-12"></span>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="deviceTypes.length">
                      <tr v-for="(type, typeIndex) in deviceTypes" :key="typeIndex">
                        <td>{{ type.deviceType }}</td>
                        <td>{{ type.description }}</td>
                        <td>
                          <template v-if="type.tags?.length">
                            <span v-for="(tag, tagIndex) in type.tags" :key="tagIndex" class="badge bg-info text-dark me-1">
                              {{ tag }}
                            </span>
                          </template>
                          <span v-else class="text-muted">—</span>
                        </td>
                        <td>
                          <template v-if="type.details?.interfaces?.length">
                            <span v-for="(typeInterface, interfaceIndex) in type.details.interfaces" :key="interfaceIndex" class="badge bg-primary me-1">
                              {{ typeInterface }}
                            </span>
                          </template>
                          <span v-else class="text-muted">—</span>
                        </td>
                        <td>{{ type.cpuCount }}</td>
                        <td>
                          <div class="d-flex gap-2">
                            <router-link :to="'/device/types/' + type.id + '/edit'" class="btn btn-primary bg-gradient btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit">
                              <eva-icon name="edit" data-eva-height="14" data-eva-width="14" class="fill-white align-text-top"></eva-icon>
                            </router-link>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="7" class="text-center">No device types found</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <div v-if="!loading && deviceTypes.length" class="card-footer">
          <pagination :baseUrl="baseUrl" :totalItems="totalItems" :perPage="perPage" :currentPage="currentPage + 1" @page-changed="updatePage" />
        </div>
      </div>
    </div>
  </div>
</template>
